module.exports = __webpack_public_path__ + "img/b0ded73.jpg";